export default __webpack_public_path__ + "static/media/37-ChampagneNicolas.458d7646.jpg";